import React from "react";

export const CrossBannerSvg = ({size = 20, ...props}) => {
    return (
        <svg
            {...props}
            width={size} height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor">
            <path d="M12 2V22M7 7H17"/>
        </svg>
    );
}

export const CrossObituarySvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size} height={size}
            viewBox="0 0 64 64"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path fill="currentColor" d="M18.047 24.893a3.098 3.098 0 002.97 2.237 5.717 5.717 0 002.507-.578 12.97 12.97 0 014.956-1.292 113.729 113.729 0 01-1.407 15.149h9.864a113.732 113.732 0 01-1.408-15.15 12.97 12.97 0 014.957 1.293 5.748 5.748 0 002.507.578 3.11 3.11 0 002.98-2.237 3.806 3.806 0 002.96-3.712 3.15 3.15 0 00-.926-2.228 3.224 3.224 0 00-2.266-.925h-.058a2.894 2.894 0 00-3.355-1.833 3.225 3.225 0 00-1.225.328 15.846 15.846 0 01-5.535 1.456c.54-4.802 1.456-5.438 1.475-5.448a1.765 1.765 0 00.916-1.524 3.516 3.516 0 00-2.651-3.403 3.394 3.394 0 00-6.606 0 3.521 3.521 0 00-2.642 3.413 1.782 1.782 0 00.926 1.524c.01.01.916.626 1.465 5.438a15.982 15.982 0 01-5.554-1.456 3.266 3.266 0 00-1.205-.328 2.895 2.895 0 00-2.46.57 2.847 2.847 0 00-.906 1.272l-.086-.01a3.163 3.163 0 00-3.163 3.154 3.806 3.806 0 002.97 3.712zM19.975 41.855a.967.967 0 00-.964.964v5.198H44.99v-5.198a.967.967 0 00-.964-.964z" />
            <rect fill="currentColor" height={9.537} rx={0.964} width={38.61} x={12.695} y={49.463} />
        </svg>
    );
}

